import { render, staticRenderFns } from "./MerchantInfoItem.vue?vue&type=template&id=2015cbc5&scoped=true"
import script from "./MerchantInfoItem.vue?vue&type=script&lang=js"
export * from "./MerchantInfoItem.vue?vue&type=script&lang=js"
import style0 from "./MerchantInfoItem.vue?vue&type=style&index=0&id=2015cbc5&lang=scss"
import style1 from "./MerchantInfoItem.vue?vue&type=style&index=1&id=2015cbc5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015cbc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2015cbc5')) {
      api.createRecord('2015cbc5', component.options)
    } else {
      api.reload('2015cbc5', component.options)
    }
    module.hot.accept("./MerchantInfoItem.vue?vue&type=template&id=2015cbc5&scoped=true", function () {
      api.rerender('2015cbc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/MerchantInfoItem.vue"
export default component.exports